"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutPreview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section id="about-preview" className="bg-background py-16 lg:py-24">
      <div className="container mx-auto max-w-3xl px-6">
        <div ref={ref} className={`flex flex-col items-center text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"}`}>
          <h2 className="font-display text-3xl lg:text-4xl font-bold tracking-tight text-foreground mb-4">
            Our Mission
          </h2>
          <p className="text-foreground text-base lg:text-lg leading-relaxed mb-8 max-w-2xl">
            At ABA With Passion Inc, we are committed to providing compassionate, evidence-based Applied Behavior Analysis therapy to children and adolescents with autism and developmental needs. Our bilingual, family-centered approach empowers parents and caregivers with the tools and support they need to help their loved ones thrive.
          </p>
          <Link to="/AboutUsPage">
            <Button variant="outline" size="lg" className="border-primary text-primary hover:bg-primary hover:text-foreground-primary transition-all duration-[var(--duration-fast)]">
              Learn More
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}